export default __webpack_public_path__ + "static/media/materials.b8f83f65.svg";